import * as React from "react";

function SvgTalonOne(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 585 785"
      {...{ ...props, ref }}
    >
      <path fill="#05C8FF" d="M250 660V375h285z" />
      <path fill="#1469FF" d="M375 375H125V125z" />
      <path fill="#000078" d="M125 375h125v125z" />
    </svg>
  );
}

export default React.forwardRef(SvgTalonOne);
